import { render } from "./ContactSchemaJson.vue?vue&type=template&id=752d9eb5"
import script from "./ContactSchemaJson.vue?vue&type=script&lang=js"
export * from "./ContactSchemaJson.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__